"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DictionaryEvidence = __importStar(require("../../composite/evidence/dictionary-evidence/dictionary-evidence"));
const evidence_1 = require("../../composite/evidence/evidence");
const empty_component_1 = require("../../utils/empty-component");
const translations_columns_1 = require("./translations-columns");
const translations_fields_1 = require("./translations-fields");
const translations_schema_1 = require("./translations-schema");
function translationsFactory(url, reportTag) {
    return function Translations() {
        const intl = (0, react_intl_1.useIntl)();
        const validationSchema = (0, translations_schema_1.useValidationSchema)();
        const evidence = DictionaryEvidence.useDictionaryEvidence({
            identifier: 'TRANSLATIONS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: (0, translations_columns_1.useColumns)(),
                tableName: intl.formatMessage({
                    id: 'EAS_TRANSLATIONS_TABLE_TITLE',
                    defaultMessage: 'Překlady',
                }),
                reportTag,
            },
            detailProps: {
                GeneralFieldsComponent: empty_component_1.EmptyComponent,
                FieldsComponent: translations_fields_1.TranslationsFields,
                validationSchema,
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'EAS_TRANSLATIONS_DETAIL_TITLE',
                        defaultMessage: 'Překlad',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
    };
}
exports.translationsFactory = translationsFactory;
//# sourceMappingURL=translations.js.map